export const articles = [
  {
    id: 1,
    slug: "kakobuy-spreadsheet-polska-2026",
    title: "Kakobuy Spreadsheet Polska 2026 – Kompletny Przewodnik",
    excerpt: "Wszystko, co musisz wiedzieć o arkuszu Kakobuy Spreadsheet w Polsce. Sprawdź najnowsze kategorie, ceny i porady dotyczące zamawiania produktów z Chin.",
    category: "Przewodnik",
    imageSeq: "article-hero-01",
    imageQuery: "Lifestyle%20flat%20lay%20with%20fashion%20items%20laptop%20and%20coffee%20on%20light%20sage%20green%20background%2C%20soft%20morning%20light%2C%20editorial%20photography%2C%20modern%20European%20workspace%20aesthetic%2C%20calm%20organic%20composition%2C%20subtle%20shadows%2C%20minimal%20style",
  },
  {
    id: 2,
    slug: "jak-korzystac-z-kakobuy-spreadsheet",
    title: "Jak Korzystać z Kakobuy Spreadsheet – Poradnik Krok po Kroku",
    excerpt: "Praktyczny poradnik dla początkujących – naucz się efektywnie korzystać z arkusza Kakobuy Spreadsheet i znajdź najlepsze produkty w kilka minut.",
    category: "Poradnik",
    imageSeq: "article-hero-02",
    imageQuery: "Hands%20typing%20on%20laptop%20with%20fashion%20sketches%20and%20fabric%20samples%20on%20light%20terracotta%20desk%2C%20warm%20studio%20lighting%2C%20editorial%20photography%2C%20creative%20workspace%2C%20organised%20composition%2C%20soft%20shadows%2C%20modern%20minimal%20aesthetic",
  },
  {
    id: 3,
    slug: "najlepsze-produkty-kakobuy",
    title: "Najlepsze Produkty Kakobuy – Top 10 Kategorii w 2026 Roku",
    excerpt: "Ranking 10 najpopularniejszych kategorii produktów dostępnych w Kakobuy Spreadsheet. Od butów sportowych po ekskluzywne perfumy.",
    category: "Ranking",
    imageSeq: "article-hero-03",
    imageQuery: "Curated%20collection%20of%20diverse%20fashion%20products%20arranged%20on%20light%20lavender%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20product%20photography%2C%20modern%20minimal%20aesthetic%2C%20harmonious%20color%20palette%2C%20clean%20composition",
  },
  {
    id: 4,
    slug: "czy-kakobuy-jest-bezpieczny",
    title: "Czy Kakobuy Jest Bezpieczny? – Pełna Analiza Bezpieczeństwa",
    excerpt: "Szczegółowa analiza bezpieczeństwa zakupów przez Kakobuy. Ochrona płatności, weryfikacja sprzedawców i praktyczne wskazówki.",
    category: "Bezpieczeństwo",
    imageSeq: "article-hero-04",
    imageQuery: "Security%20concept%20with%20shield%20icon%20and%20shopping%20bags%20on%20light%20sand%20background%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20trust%20and%20safety%20theme%2C%20minimal%20composition%2C%20warm%20reassuring%20tones",
  },
  {
    id: 5,
    slug: "opinie-uzytkownikow-kakobuy",
    title: "Opinie Użytkowników Kakobuy – Prawdziwe Recenzje Polaków",
    excerpt: "Zebraliśmy autentyczne opinie polskich użytkowników Kakobuy. Dowiedz się, jakie są ich doświadczenia z zamawianiem produktów z Chin.",
    category: "Opinie",
    imageSeq: "article-hero-05",
    imageQuery: "Happy%20customer%20unboxing%20fashion%20package%20on%20light%20peach%20background%2C%20warm%20natural%20lighting%2C%20editorial%20lifestyle%20photography%2C%20authentic%20joyful%20moment%2C%20modern%20European%20aesthetic%2C%20soft%20shadows",
  },
  {
    id: 6,
    slug: "koszty-wysylki-kakobuy",
    title: "Koszty Wysyłki Kakobuy do Polski – Pełne Zestawienie 2026",
    excerpt: "Ile kosztuje wysyłka z Kakobuy do Polski? Porównujemy wszystkie metody dostawy, czasy i ceny – wybierz najlepszą opcję.",
    category: "Wysyłka",
    imageSeq: "article-hero-06",
    imageQuery: "Cardboard%20shipping%20box%20with%20packing%20materials%20on%20light%20mint%20green%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20delivery%20concept%2C%20minimal%20composition%2C%20clean%20and%20fresh%20aesthetic",
  },
  {
    id: 7,
    slug: "jak-uniknac-oszustw-kakobuy",
    title: "Jak Uniknąć Oszustw na Kakobuy – 10 Najważniejszych Zasad",
    excerpt: "Poznaj sprawdzone sposoby na unikanie oszustw podczas zakupów przez Kakobuy. Chroń swoje pieniądze i zamawiaj bezpiecznie.",
    category: "Bezpieczeństwo",
    imageSeq: "article-hero-07",
    imageQuery: "Magnifying%20glass%20over%20product%20photos%20on%20light%20blush%20pink%20background%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20fraud%20prevention%20concept%2C%20minimal%20composition%2C%20clean%20professional%20aesthetic",
  },
  {
    id: 8,
    slug: "kakobuy-vs-pandabuy",
    title: "Kakobuy vs Pandabuy – Który Agent Zakupowy Jest Lepszy?",
    excerpt: "Porównanie dwóch najpopularniejszych agentów zakupowych z Chin. Kakobuy czy Pandabuy? Sprawdź ceny, produkty i opinie.",
    category: "Porównanie",
    imageSeq: "article-hero-08",
    imageQuery: "Split%20comparison%20concept%20with%20two%20shopping%20carts%20on%20light%20dusty%20rose%20background%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20versus%20theme%2C%20minimal%20composition%2C%20balanced%20symmetric%20layout",
  },
  {
    id: 9,
    slug: "poradnik-poczatkujacego-kakobuy",
    title: "Poradnik Początkującego Kakobuy – Od A do Z w 15 Minut",
    excerpt: "Szybki start z Kakobuy Spreadsheet. W 15 minut nauczysz się zamawiać produkty z Chin – nawet jeśli robisz to pierwszy raz.",
    category: "Poradnik",
    imageSeq: "article-hero-09",
    imageQuery: "Open%20notebook%20with%20handwritten%20shopping%20notes%20and%20fashion%20items%20on%20light%20oatmeal%20background%2C%20soft%20warm%20lighting%2C%20editorial%20lifestyle%20photography%2C%20learning%20concept%2C%20minimal%20composition%2C%20cozy%20aesthetic",
  },
];

export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  imageSeq: string;
  imageQuery: string;
}